import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addFeedbackRes;
export const addFeedbackTodo = createAsyncThunk('addFeedback', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/submit_feedback',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": val.course_id,
                "fk_training_id": val.training_id,
                "feedback_ans": val.feedback_ans,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addFeedbackRes = res.data
    } catch (error) {
        return addFeedbackRes = error.response.data
    }
})